import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Download, FileText, Loader2, Copy, Check } from 'lucide-react';
import { getHandoverDocument } from 'zite-endpoints-sdk';
import { toast } from 'sonner';

export default function HandoverDocuments() {
  const [downloading, setDownloading] = useState(false);
  const [copying, setCopying] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const { content, filename } = await getHandoverDocument({});
      const blob = new Blob([content], { type: 'text/markdown' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success('Document downloaded!');
    } catch {
      toast.error('Failed to download document');
    } finally {
      setDownloading(false);
    }
  };

  const handleCopy = async () => {
    setCopying(true);
    try {
      const { content } = await getHandoverDocument({});
      await navigator.clipboard.writeText(content);
      toast.success('Copied to clipboard!');
      setTimeout(() => setCopying(false), 2000);
    } catch {
      toast.error('Failed to copy');
      setCopying(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">Handover Documents</h1>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <FileText className="w-6 h-6 text-primary" />
            </div>
            <div>
              <CardTitle className="text-lg">Floor / Table Planner — Developer Handover</CardTitle>
              <CardDescription>
                Complete technical handover for rebuilding the Floor Plans &amp; Table Planner module in the BMS Portal
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            Includes database schema, canvas architecture, fixture types, layout management, AI auto-arrange, 
            email/print export, all 15 backend endpoints, seed data, and implementation notes.
          </p>
          <div className="flex gap-3">
            <Button onClick={handleDownload} disabled={downloading}>
              {downloading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
              Download .md
            </Button>
            <Button variant="outline" onClick={handleCopy} disabled={copying}>
              {copying ? <Check className="w-4 h-4 mr-2" /> : <Copy className="w-4 h-4 mr-2" />}
              {copying ? 'Copied!' : 'Copy to Clipboard'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
